import {
  PModal,
  PButtonGroup,
  PHeading,
} from "@porsche-design-system/components-react";
import CButton from "Components/CComponents/CButton/CButton";
import CText from "Components/CComponents/CText/CText";
import { useTranslation } from "react-i18next";

export const ClosingModal = ({
  accept,
  onDismiss,
  questionText,
  descriptionText,
}) => {
  const { t } = useTranslation("leaving");

  return (
    <>
      <PModal
        open={true}
        onDismiss={onDismiss}
        aria={{ "aria-label": "Some Heading" }}
      >
        <PHeading slot="header" size="large" tag="h2">
          {questionText || t("modal.head")}
        </PHeading>
        <CText>{descriptionText || t("modal.line")}</CText>
        <PButtonGroup slot="footer">
          <CButton type="button" onClick={accept}>
            {t("modal.button.accept")}
          </CButton>
          <CButton type="button" variant="secondary" onClick={onDismiss}>
            {t("modal.button.decline")}
          </CButton>
        </PButtonGroup>
      </PModal>
      ) :
    </>
  );
};
